// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"1e70e5ebf4fe7b502d1b","245":"b0cbbb0672100357090b","452":"8c814b40c90aa22d578a","453":"98cea6ee32d1d7da759e"}[chunkId] + ".js";
};